import { FC } from 'react';
import styled from 'styled-components';

import { baseColors, spacing, body2, colors } from 'ui/theme';
import { NodeType } from '../types';

export type RowProps = {
  className?: string;
  indent?: boolean;
};

const RowWrapper = styled.div<RowProps>`
  ${body2}
  color: ${colors.textPrimary};
  ${({ indent = true }) =>
    indent ? `padding-left: ${spacing.plusQuarter}; border-left: 1px solid transparent;` : ''}

  .json-property-value {
    color: ${colors.textPrimary};

    &.json-property-${NodeType.string} {
      color: ${baseColors.purple100};
    }

    &.json-property-${NodeType.number} {
      color: ${baseColors.green100};
    }

    &.json-property-${NodeType.boolean} {
      color: ${baseColors.red100};
    }
  }
`;

export const Row: FC<React.PropsWithChildren<RowProps>> = ({ children, ...props }) => {
  return (
    <RowWrapper className="json-property" {...props}>
      {children}
    </RowWrapper>
  );
};
